import { render, staticRenderFns } from "./AdminAccountEdit.vue?vue&type=template&id=4701b82c&"
import script from "./AdminAccountEdit.vue?vue&type=script&lang=js&"
export * from "./AdminAccountEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports